import React, {useState, useEffect} from 'react';
import Navbar from '../Navegation/Navbar';
import Footer from '../Navegation/Footer';
import imageSrc from '../../Img/Post/img3.jpg';
import imageSrc2 from '../../Img/Post/img4.jpg';
import imageSrc3 from '../../Img/Post/nhsPoster.jpg'

function Clip() {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const main = {
        width: '100%',
        display: 'flex',
        backgroundColor: '#efeeea',
        justifyContent:'space-between',
        flexDirection:  windowWidth <= 689 ? 'column' : 'row'
    }
    const title = {
        fontFamily: 'Stadium',
        fontSize: '7em',
        color: '#31453a',
        letterSpacing: '5px',
        padding: '2%'
    }
    const subtitle = {
        fontFamily: 'Sarabun',
        fontSize: '2em',
        color: '#31453a'
    }
    const sup = {
        display: 'flex',
        flexFlow: 'row',
        alignItems: 'flex-start',
        width: windowWidth <= 689 ? '100%' : '50%',
        flexDirection:'column'
    }
    const inf = {
        display: 'flex',
        flexDirection: windowWidth <= 689 ? 'column':'row',
        flexWrap: 'nowrap',
        alignContent: 'center',
        alignItems: windowWidth <= 689 ? 'center':'',
        placeContent: 'center',
        justifyContent: 'center'
    }
    const right = {
        width: '60%',
        margin: '0% 10%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        fontFamily: 'SarabunRegular',
        fontSize: '1.1em',
        color: '#31453a'
    }
    const poster = {
        width:windowWidth <= 689 ? '50%':'30%',
        padding: windowWidth <= 689 ? '1%':'5%'
    }
    const img = {
        flex: '0 0 auto',
        maxWidth: '100%',
        height: 'auto',
        objectFit: 'cover',
    }
    const container = {
        width: windowWidth <= 689 ? '100%':'50%',
        display: 'flex',
        flexFlow: 'column',
        padding: windowWidth <= 689 ? '5%':'0%',
        gap: '5px',
        alignItems: 'flex-end',
        justifyContent: 'flex-start',
        alignContent: 'flex-end'
    }    
    const image = {
        flex: '0 0 auto',
        maxWidth: '100%',
        height: 'auto',
        objectFit: 'cover',
    }
    const divVideo = {
        backgroundColor: '#efeeea',
        height: '105vh',
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center'
    }
    const video = {
        width: '90%',
        height: '100%',
        padding: '1%'
    }

    // Actualiza el ancho de la ventana cuando cambia
    useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);


  return (
    <>
      <Navbar />
        <div style={main}>
            <div style={sup}>
            <h1 style={title}>NO HAY SENAL</h1>
            <div style={inf}>
                <div style={poster}>
                    <img src={imageSrc3} alt="" style={img} />
                </div>
                    <div style={right}>                    
                        <h2 style={subtitle}>SINOPSIS</h2>
                        <p>Julieta tiene una conversación con su pareja sobre lo sucedido en la fiesta.</p>
                        <h2 style={subtitle}>FICHA TÉCNICA</h2>
                        <p>Director <br/> Pablo Biott<br/></p>
                        <p>Producción <br/>Valentín Caballaro y Pablo Biott</p>
                        <p>Guión <br/>Valentín Caballaro y Pablo Biott</p>
                        <p>Piloto de drone <br/> Sebastián Maruzzi</p>
                        <p>Dirección de fotografía <br/> Juan Cruz Biott</p>
                        <p>Sonido Directo <br/> Ayelén Mascaro</p>
                        <p>Montaje <br/> Pablo Biott</p>
                    </div>
            </div>
            </div>
            <div style={container}>
                <img src={imageSrc} alt="" style={image} />
                <img src={imageSrc2} alt="" style={image} />
            </div>
        </div>
        <div style={divVideo}>
            <iframe style={video} src="https://www.youtube.com/embed/TO5WAvlXPS4" title="NO HAY SEÑAL | TRAILER | NIEBLA films" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
      <Footer />
    </>
  );
}

export default Clip;
